<template>
  <el-dialog title="代金券支付" :visible="visible" :show-close="false">
    <div v-if="!showForm" style="text-align:center;height:180px;">
      请<el-button type="text" @click="readIdcard">刷身份证</el-button>&nbsp;或<el-button type="text" @click="showForm = true">输入代金券号码</el-button>
    </div>
    <el-form label-width="200px" v-if="showForm">
      <el-form-item label="代金券号码" prop="coupon_no">
        <el-input v-model="coupon_no" style="width:330px">
          <el-button slot="append" @click="getCoupon" :disabled="coupon_no.length == 0">查询代金券</el-button>
        </el-input>
      </el-form-item>
      <el-form-item v-if="coupon_owner" label="拥有者">
        {{ coupon_owner }}
      </el-form-item>
      <el-form-item v-if="coupon_money > 0" label="金额">
        {{ coupon_money }}
      </el-form-item>
      <el-form-item v-if="coupon_money > 0">
        <el-button type="primary" @click="commit" :disabled="coupon_money == 0 || commiting" :loading="commiting">确定使用</el-button>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    billId: {
      type: Number,
      required: true
    },
    companyId: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showForm: false,
      coupon_no: '',
      coupon_owner: '',
      coupon_money: 0,
      idcardReading: false,
      commiting: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.showForm = false
        this.coupon_no = ''
        this.coupon_owner = ''
        this.coupon_money = 0
      }
    }
  },
  methods: {
    readIdcard () {
      if (this.idcardReading) {
        return
      }
      this.idcardReading = true
      this.$idcard.read().then(data => {
        this.idcardReading = false
        this.coupon_no = data.code
        this.getCoupon()
      }).catch(() => {
        this.idcardReading = false
      })
    },
    getCoupon () {
      this.$http.get(`/dbapi/coupon_unused?company_id=${this.companyId}&coupon_no=${this.coupon_no}`).then(response => {
        if (response.data.success) {
          if (response.data.list.length === 0) {
            this.$message({
              type: 'error',
              message: '没有找到代金券信息,或代金券已被使用'
            })
            return
          } else {
            let c = response.data.list[0]
            this.coupon_no = c.coupon_no
            this.coupon_owner = c.coupon_owner
            this.coupon_money = c.coupon_money
            this.showForm = true
          }
        }
      })
    },
    commit: _.throttle(
      function () {
        this.commiting = true
        this.$http.post('/dbapi/add_pay_coupon', {
          id: this.billId,
          money: this.coupon_money,
          coupon_no: this.coupon_no
        }).then(response => {
          this.commiting = false
          this.$emit('commit')
        })
      },
      5000
    ),
    close () {
      this.$emit('cancel')
    }
  }
}
</script>

<style>
.pay-form .el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/rent/PayCouponDialog.vue